import StatusBadge from "../intelligence/StatusBadge";

const LABELS = {
  stub_only: "Stub only",
  discovery_pending: "Discovery pending",
  not_configured: "Not configured",
  failing: "Failing",
  degraded: "Degraded",
  healthy: "Healthy",
  warning: "Warning",
  error: "Error",
  completed: "Completed",
  completed_with_errors: "Completed w/ errors",
  failed: "Failed",
  started: "Started",
  running: "Running",
  never_run: "Never Run",
  stale: "Stale",
  disabled: "Disabled",
  planned: "Planned",
  pending_config: "Pending setup",
  success: "Success",
  partial_success: "Partial success",
  not_configured: "Not configured",
  failed: "Failed",
  queued: "Queued",
  cancelled: "Cancelled",
  ok: "OK",
  unknown: "Unknown",
  inventory_only: "Inventory only",
  inventory_active: "Inventory only",
  planning_only: "Planning only",
  compliance_only: "Compliance only",
  discovery_only: "Discovery only",
  compliance_review: "Compliance review",
  partner_access_required: "Partner access required",
  blocked: "Blocked",
  deferred: "Deferred",
  retired: "Retired",
  not_wired: "Not wired for ingest",
  needs_ingest_registration: "Needs ingest registration",
  partner_feed: "Partner feed preferred",
  reference_only: "Reference only",
  do_not_use: "Do not use",
  manual_only: "Manual only",
  manual_ingest_validated: "Manual ingest validated",
  manual_ingest_validated_with_warnings: "Validated with warnings",
  wiring_in_progress: "Wiring in progress",
  paired_adapter_pending: "Paired — adapter scaffolded",
};

const TONES = {
  stub_only: "medium",
  discovery_pending: "medium",
  not_configured: "neutral",
  failing: "disputed",
  degraded: "medium",
  healthy: "confirmed",
  warning: "medium",
  error: "disputed",
  completed: "confirmed",
  completed_with_errors: "medium",
  failed: "disputed",
  started: "neutral",
  running: "neutral",
  never_run: "medium",
  stale: "medium",
  disabled: "neutral",
  planned: "neutral",
  pending_config: "medium",
  success: "confirmed",
  queued: "neutral",
  cancelled: "neutral",
  ok: "confirmed",
  unknown: "neutral",
  inventory_only: "neutral",
  inventory_active: "neutral",
  planning_only: "neutral",
  compliance_only: "neutral",
  discovery_only: "neutral",
  compliance_review: "medium",
  partner_access_required: "medium",
  blocked: "disputed",
  deferred: "neutral",
  retired: "neutral",
  not_wired: "neutral",
  needs_ingest_registration: "medium",
  partner_feed: "neutral",
  reference_only: "neutral",
  do_not_use: "disputed",
  manual_only: "neutral",
  manual_ingest_validated: "confirmed",
  manual_ingest_validated_with_warnings: "medium",
  wiring_in_progress: "neutral",
  paired_adapter_pending: "neutral",
};

const SourceHealthBadge = ({ status }) => {
  const normalized = status || "unknown";

  return (
    <StatusBadge
      label={LABELS[normalized] || normalized.replace(/_/g, " ")}
      tone={TONES[normalized] || "neutral"}
    />
  );
};

export default SourceHealthBadge;
